import { RootReducer } from 'store/reducers';
// import { createSelector } from 'reselect';
// import { SsiWarningSafety, SsiWarningStyle } from 'types/check';

export const assessment = (state: RootReducer) => state.assessment;

export const getJobToken = (state: RootReducer) => state.assessment.jobToken;

export const isBrandedDocument = (state: RootReducer) => state.assessment.isBrandedDocument;

export const getSupportedReviews = (state: RootReducer) => state.assessment.supportedReviews;

// TO DO: refactor, because no warning propreties in assessmentSsiVersions
// export const assessmentWarnings = (state: RootReducer) =>
//   state.assessment.assessmentSsiVersions[0];

export const messages = (state: RootReducer) => state.messages;

// export const isDocumentStyleAvailable = createSelector(
//   assessmentWarnings,
//   (assessmentWarnings): boolean =>
//     !~Object.values(SsiWarningStyle).indexOf(
//       assessmentWarnings?.warningStyle?.code as SsiWarningStyle
//     )
// );

// export const isDocumentSafetyAvailable = createSelector(
//   assessmentWarnings,
//   (assessmentWarnings): boolean => {
//     return (
//       assessmentWarnings?.warningSafety?.code !==
//       SsiWarningSafety.SSI_CHECK_FOR_UNBRANDED_IS_UNSUPPORTED
//     );
//   }
// );
